import { render, staticRenderFns } from "./DataReportResult.vue?vue&type=template&id=2aa0792c&scoped=true"
import script from "./DataReportResult.vue?vue&type=script&lang=js"
export * from "./DataReportResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa0792c",
  null
  
)

export default component.exports